export const dxs = [+1, 0, -1, 0, +1, +1, -1, -1];
export const dys = [0, +1, 0, -1, +1, -1, +1, -1];
